import { render } from "./huasTrade.vue?vue&type=template&id=16a7fd06&scoped=true"
import script from "./huasTrade.vue?vue&type=script&lang=js"
export * from "./huasTrade.vue?vue&type=script&lang=js"

import "./huasTrade.vue?vue&type=style&index=0&id=16a7fd06&lang=scss&scoped=true"
import "./huasTrade.vue?vue&type=style&index=1&id=16a7fd06&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a7fd06"]])

export default __exports__